import { createContext } from 'react';

export const CatalogContext = createContext({});

